import React from 'react';
import { Link } from 'react-router-dom';
interface LogoProps {
  to?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
const sizes: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'text-lg tracking-[0.32em]',
  md: 'text-2xl tracking-[0.34em]',
  lg: 'text-4xl tracking-[0.36em]'
};
export function Logo({
  to = '/',
  size = 'md',
  className = ''
}: LogoProps) {
  return <Link to={to} aria-label="ZADAR — inicio" className={`group inline-flex items-center gap-2 font-display font-bold uppercase leading-none text-white ${sizes[size]} ${className}`} data-id="element-640" data-mp="msuoe0z57rbp">
      <span className="block h-[1.05em] w-[3px] bg-pink-500 transition-all duration-300 group-hover:h-[1.3em]" data-id="element-641" data-mp="dsg14w2mc25k" />
      <span data-id="element-642" data-mp="ht00m6anzhuv">ZADAR</span>
    </Link>;
}